import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Globe, Menu, X } from "lucide-react";

export const SiteHeader = ({ lang, setLang }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const hi = lang === "hi";
  const links = [
    { to: "/", label: hi ? "होम" : "Home" },
    { to: "/offers", label: hi ? "ऑफर" : "Offers" },
    { to: "/how-to-play", label: hi ? "कैसे खेलें" : "How to Play" },
    { to: "/contact", label: hi ? "संपर्क" : "Contact" },
  ];

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4">
        <Link to="/" className="font-display text-2xl font-bold tracking-tight" data-testid="logo">
          CRIC<span className="gold-text">1X</span>
        </Link>
        <nav className="hidden items-center gap-8 font-mono text-[12px] uppercase tracking-[0.2em] text-white/60 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`transition-colors hover:text-gold ${pathname === l.to ? "text-gold" : ""}`}
              data-testid={`nav-${l.to === "/" ? "home" : l.to.slice(1)}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={() => setLang(hi ? "en" : "hi")}
            className="flex items-center gap-1.5 border border-white/15 px-3 py-2 font-mono text-[11px] uppercase tracking-widest text-white/80 transition-colors hover:border-gold hover:text-gold"
            data-testid="lang-toggle"
          >
            <Globe size={13} /> {hi ? "EN" : "हिंदी"}
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center border border-white/15 p-2 text-white/80 transition-colors hover:border-gold hover:text-gold md:hidden"
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-white/10 bg-black/95 px-5 py-4 md:hidden" data-testid="mobile-menu">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={`block py-3 font-mono text-[13px] uppercase tracking-[0.2em] transition-colors ${pathname === l.to ? "text-gold" : "text-white/70"}`}
              data-testid={`mobile-nav-${l.to === "/" ? "home" : l.to.slice(1)}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
};
